"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ButtonWs = _interopRequireDefault(require("./Button.ws10.theme"));

var _ButtonVoxi = _interopRequireDefault(require("./Button.voxi.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getLocalTheme = function getLocalTheme(theme) {
  switch (theme.name) {
    case 'VOXI':
      return (0, _ButtonVoxi["default"])(theme);

    case 'WS2':
    case 'WS10':
    default:
      return (0, _ButtonWs["default"])(theme);
  }
};

var _default = getLocalTheme;
exports["default"] = _default;
//# sourceMappingURL=Button.theme.js.map